import React, { useContext, useState } from "react";
import { useParams } from "react-router-dom";
import { Col, Modal, Row } from "react-bootstrap";
import DetailHead from "./DetailsHead";
import { HTMLContent } from "../HTMLContent";
import "../../styles/popup.css";
import { LanguageContext } from "../../App";
import TEXT from "../../data/text";
const EventChallenges = ({ ChallengeObj, myRef }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [getChallengeDetails, setChallengeDetails] = useState({});
  const { language, languages } = useContext(LanguageContext);
  // getting challenge details by id
  const handleShow = (val) => async (e) => {
    e.preventDefault();
    let challengeId = await val;
    const challenge = await ChallengeObj.find(
      (item) => item && item.id === challengeId
    );
    if (challenge) {
      const challenge_wLanguage =
        challenge.translation?.[languages[language]] || challenge;
      setShow(true);
      setChallengeDetails(challenge_wLanguage);
    }
  };

  function Modalpop(obj) {
    obj = obj.ChallengeModal;
    return (
      <Modal
        id="Challenge_modal"
        data-target="animate"
        show={show}
        animation={false}
        onHide={() => setShow(false)}
        dialogClassName="modal-100w"
        scrollable=" "
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Body>
          <div className="close_wrap">
            <a
              // href
              role="button"
              onClick={handleClose}
              className="close_button"
            >
              x
            </a>
          </div>

          <HTMLContent className="challge_title" content={obj.title} />

          <div
            className={`poppheader ${language === "ARABIC" ? "rtl" : "ltr"}`}
            style={{ width: "80%", margin: "0px auto 25px auto" }}
          >
            <HTMLContent
              className="ideaClass"
              content={obj.challengeStatement}
            />
          </div>
          <div
            className={`pop_content ${language === "ARABIC" ? "rtl" : "ltr"}`}
          >
            <Row className="pop_row">
              <Col className="main-content" sm={12}>
                <HTMLContent className="ideaClass" content={obj.background} />
                <HTMLContent
                  className="ideaClass"
                  content={obj.ideaAndSolution}
                />
                <HTMLContent
                  className="ideaClass"
                  content={obj.currentProcesses}
                />
                <HTMLContent className="ideaClass" content={obj.postIdeathon} />
              </Col>
              <div className="et_pb_button_module_wrapper et_pb_button_0_wrapper et_pb_button_alignment_left module ">
                <a
                  role="button"
                  onClick={handleClose}
                  className="sustainathon_anim_button close_button_padding"
                >
                  <span>{TEXT[language]["SUSTAINATHONS"]["2"]}</span>
                </a>
              </div>
            </Row>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <div ref={myRef} className="challenges">
      {show && <Modalpop ChallengeModal={getChallengeDetails} />}
      <div className="et_pb_section challenge_section et_section_regular">
        <div className="container">
          <DetailHead title={TEXT[language]["SUSTAINATHONS"]["9"]} />
          <div className="module et_pb_text click_on_challenge  et_pb_bg_layout_light">
            <div className="et_pb_text_inner">
              <p style={{ textAlign: "center" }}>
                <strong>{TEXT[language]["SUSTAINATHONS"]["3"]}</strong>
              </p>
            </div>
          </div>
        </div>
        <div className="container challenges_container">
          <div
            className="row"
            style={{
              justifyContent: "center",
            }}
          >
            {ChallengeObj.length > 0 ? (
              ChallengeObj.map((eachChallenge, index) => {
                const Challenge =
                  eachChallenge.translation?.[languages[language]] ||
                  eachChallenge;
                return (
                  <div
                    key={index}
                    data-aos="zoom-in-down"
                    data-aos-delay="0"
                    data-aos-duration="800"
                    className="col-lg-4 col-md-6 col-sm-12 challenge_margin"
                    value={eachChallenge.id}
                    onClick={(e) => handleShow(eachChallenge.id)(e)}
                    id="cc"
                  >
                    <div className="challenge_card module  et_pb_blurb et_pb_blurb_0 et_clickable et_pb_text_align_center et_pb_blurb_position_top et_pb_bg_layout_light popup-trigger et_pb_blurb_content">
                      {Challenge.imageUrl ? (
                        <div className="et_pb_main_blurb_image">
                          <a
                            // href
                            data-area-id="#test"
                            className="popup-trigger"
                          >
                            <span className="challenge_image_wrap">
                              <img
                                loading="lazy"
                                src={Challenge.imageUrl}
                                alt=""
                                className="et-waypoint et_pb_animation_top et-animated"
                              />
                            </span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}

                      <div className="et_pb_blurb_container">
                        <h4 className="et_pb_module_header">
                          <a
                            // href
                            className="popup-trigger"
                            value={Challenge.id}
                            onClick={(e) => handleShow(Challenge.id)(e)}
                          >
                            <HTMLContent
                              className="challenge_title"
                              content={Challenge.title}
                            />
                          </a>
                        </h4>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <h4 style={{ color: "#000" }}>
                {TEXT[language]["SUSTAINATHONS"]["4"]}
              </h4>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventChallenges;
